module Meevo.Components.BaseClasses {
    "use strict";

    export abstract class EmployeeSectionBase<T> extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<T> {

        public emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            appSettings?: Components.Common.IAppSettings,
            sectionSecurityKey?: string,
            protected translateService?: angular.translate.ITranslateService) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings,
                sectionSecurityKey);
        }


        get modelIsSomething(): boolean {
            return Model.Guard.isSomething(this.model);
        }

        get emailRequired(): boolean {
            return this.modelIsSomething && this.usersSettings && this.usersSettings.requireEmailAddress;
        }

        get usersSettings(): Meevo.Model.UsersSettings {
            return this.appSettings.APP_BUSINFOSETTINGS.usersSettings;
        }

        /**
         * Handles disabling the email opt-in if an email address isn't present.
         * This works in conjunction w/ the context.isDisabled property.
         */
        get disableEmailOptinIn(): boolean {
            const model = this.model as Model.User;
            let retVal = false;
            if (this.model && (!model.emailAddress || _.isEmpty(model.emailAddress))) {
                retVal = true;
                model.isEmailCommStatusOptedIn = false;
            }
            return retVal;
        }
    }
}